import {
  slugToComponentName,
} from '../../../../helpers';

function getComponentPaths(urlEls) {

  const path = urlEls.reduce((acc, el) => {
    const componentName = slugToComponentName(el);
    acc.push(componentName);
    return acc;
  }, []).join('/');

  return {
    base: `./${path}`,
    component: `./${path}`,
    defaultValues:  `./${path}/defaultValues.js`,
    fields: `./${path}/fields.js`,
    formName: `./${path}/formName.js`,
  }
}

export default getComponentPaths;
